(function() {
    'use strict';

    angular
        .module('atheer')
        .controller('SessionTimeoutController', SessionTimeoutController);

    /* @ngInject */
    function SessionTimeoutController($mdDialog, $interval, Idle, Auth, $state, Keepalive, SessionLastActive) {
        var vm = this;

        vm.counter = 10;
        var timer = $interval(function() {
            if(vm.counter == 0) {
                closeDialog();
            }
            vm.counter--;
        }, 1000);

        function closeDialog() {
            $interval.cancel(timer);
            $mdDialog.cancel();
            Auth.logout();
            $state.go('account.signout');
        };

        vm.close = function() {
            closeDialog();
        };

        vm.continue = function() {
            $interval.cancel(timer);
            $mdDialog.cancel();
            Keepalive.setInterval(15);
            // Refresh the shared idle clock so the extended session is
            // visible to ibm-frontend on the same origin too.
            SessionLastActive.writeSessionLastActiveAt();
            Idle.watch();
        };
    }
})();
